/** Input limits enforced by schemas on both sides of the wire. */
export const LIMITS = {
  displayName: { min: 1, max: 40 },
  login: { min: 3, max: 32, pattern: /^[a-z0-9._-]+$/ },
  password: { min: 10, max: 200 },
  title: { min: 1, max: 120 },
  trackLabel: { min: 1, max: 60 },
  chatBody: { min: 1, max: 1000 },
  pageSize: { min: 1, max: 100, default: 50 },
  subtitleFileBytes: 5 * 1024 * 1024,
  posterFileBytes: 15 * 1024 * 1024,
} as const;
